"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapXTransferSession = void 0;
const AccountService_1 = require("../AccountService");
const BaseSwapXSession_1 = require("./BaseSwapXSession");
class SwapXTransferSession extends BaseSwapXSession_1.BaseSwapXSession {
    constructor(params) {
        super(params, AccountService_1.VerifyCodeAction.swapx_transfer);
    }
    start(params, device_info, requestExecutor) {
        super.startSession(params, device_info, requestExecutor);
    }
}
exports.SwapXTransferSession = SwapXTransferSession;
